import React from "react";
export default function Team() {
  return (
    <>
      <div className="our-team" style={{"marginTop":"-80px"}}>
        <div className="team-heading" data-aos="fade-up">
          <h1>OUR TEAM</h1>
        </div>
        <p data-aos="fade-up">
          Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
          consectetur velit
        </p>
        <div className="team-cards" data-aos="fade-up">
          <div className="team-card">
            <div className="image-container">
              <img
                src=" https://img.freepik.com/premium-photo/portrait-handsome-ceo-smiling_763111-29195.jpg"
                alt="Employee 1"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Jaswant Lovanshi</h3>
              <p>CEO</p>
            </div>
          </div>
          <div className="team-card">
            <div className="image-container">
              <img
                src="https://img.freepik.com/premium-photo/portrait-happy-young-man-coder_280538-6648.jpg?semt=ais_hybrid&w=740"
                alt="Employee 2"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Tarun Lovanshi</h3>
              <p>Java Developer</p>
            </div>
          </div>
          <div className="team-card">
            <div className="image-container">
              <img
                src="https://as2.ftcdn.net/v2/jpg/06/31/24/31/1000_F_631243124_WKxshFmllxdtqDSAQOegU8i5wGD4YvWv.jpg"
                alt="Employee 3"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Deepika Lovanshi</h3>
              <p>UI/UX Designer </p>
            </div>
          </div>
          <div className="team-card">
            <div className="image-container">
              <img
                src="https://img.freepik.com/premium-photo/focused-programmer-work_1167491-4847.jpg?semt=ais_hybrid&w=740"
                alt="Employee 4"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Pankaj Lovanshi</h3>
              <p>MERN STACK Developer</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
